{
  "rewarded": true,
  "banner": true,
  "interstitial": true
}
